module.exports = "/_next/static/images/Calendar-a6d06c00a77a289d4f805f541a1a66a1.svg";